import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { API } from "../App";
import { ArrowLeft, Quote, Loader2 } from "lucide-react";
import Footer from "../components/Footer";

const Testimonials = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const response = await axios.get(`${API}/testimonials`);
        setTestimonials(response.data);
      } catch (error) {
        console.error("Error fetching testimonials:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchTestimonials();
  }, []);

  return (
    <div className="min-h-screen bg-[#F9F7F2]">
      {/* Header */}
      <header className="px-6 pt-8 pb-4">
        <div className="max-w-3xl mx-auto">
          <Link 
            to="/"
            className="inline-flex items-center gap-2 text-[#4B3329] hover:text-[#C5A059] transition-colors mb-8"
            data-testid="back-to-landing"
          >
            <ArrowLeft className="w-4 h-4" strokeWidth={1.5} />
            <span className="text-sm tracking-wide">Retour à la page d’accueil</span>
          </Link>
        </div>
      </header>

      {/* Page Title - Premium micro-heading structure */}
      <section className="px-6 py-8">
        <div className="max-w-3xl mx-auto text-center animate-fade-in-up space-y-3">
          <p className="text-[10px] sm:text-xs tracking-[0.3em] uppercase text-[#C5A059]">
            Paroles vivantes
          </p>
          <h1 
            className="font-serif text-3xl sm:text-4xl md:text-5xl text-[#3F2A24]"
            style={{ textWrap: 'balance' }}
          >
            TÉMOIGNAGES
          </h1>
          <p 
            className="font-serif text-sm sm:text-base text-[#3F2A24]/70 italic"
            style={{ textWrap: 'balance' }}
          >
            Ce que les coconé·e·s ont traversé
          </p>
          <div className="w-16 h-[1px] bg-[#C5A059]/50 mx-auto mt-4" />
        </div>
      </section>

      {/* Testimonials */}
      <section className="px-6 py-8 pb-20">
        <div className="max-w-3xl mx-auto">
          {isLoading ? (
            <div className="flex justify-center py-16">
              <Loader2 className="w-8 h-8 text-[#C5A059] animate-spin" />
            </div>
          ) : testimonials.length === 0 ? (
            <div className="text-center py-16">
              <Quote className="w-12 h-12 mx-auto mb-4 text-[#8C6A4A] opacity-30" strokeWidth={1} />
              <p className="text-[#4B3329] font-serif text-xl">
                Les témoignages arrivent bientôt...
              </p>
            </div>
          ) : (
            <div className="space-y-16 stagger-children">
              {testimonials.map((testimonial, index) => (
                <article 
                  key={testimonial.id}
                  className="animate-fade-in-up"
                  data-testid={`testimonial-${testimonial.id}`}
                >
                  {/* Testimonial */}
                  <div className="relative">
                    {/* Quote icon */}
                    <div className="absolute -top-4 -left-2 opacity-10">
                      <Quote className="w-16 h-16 text-[#C5A059]" strokeWidth={1} />
                    </div>
                    
                    {/* Testimonial text */}
                    <blockquote className="relative z-10 pl-8 border-l-2 border-[#C5A059]/30">
                      <p className="font-serif text-lg md:text-xl text-[#3F2A24] leading-relaxed whitespace-pre-wrap">
                        {testimonial.testimonial_text}
                      </p>
                      <footer className="mt-6">
                        <cite className="not-italic text-[#C5A059] font-medium tracking-wide">
                          — {testimonial.author_name}
                        </cite>
                      </footer>
                    </blockquote>
                  </div>

                  {/* Jeinar's Response */}
                  {testimonial.response_text && (
                    <div className="mt-8 ml-8 pl-6 border-l border-[#C5A059]/20">
                      <p className="text-[#4B3329] leading-relaxed whitespace-pre-wrap font-light">
                        {testimonial.response_text}
                      </p>
                      <p className="mt-4 text-sm text-[#C5A059] font-accent italic">
                        — Jeinar
                      </p>
                    </div>
                  )}

                  {/* Separator between testimonials (except last) */}
                  {index < testimonials.length - 1 && (
                    <div className="mt-16 flex justify-center">
                      <div className="w-1 h-1 rounded-full bg-[#C5A059]" />
                      <div className="w-1 h-1 rounded-full bg-[#C5A059] mx-2" />
                      <div className="w-1 h-1 rounded-full bg-[#C5A059]" />
                    </div>
                  )}
                </article>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* CTA */}
      <section className="px-6 py-12 bg-[#EAE8E1]/30">
        <div className="max-w-2xl mx-auto text-center">
          <p className="text-[#4B3329] mb-6">
            Prête à vivre ta propre transformation ?
          </p>
          <Link 
            to="/cocon-sacre"
            className="btn-sacred inline-block"
            data-testid="back-to-home-cta"
          >
            Découvrir Cocon Sacré
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Testimonials;
